<template>
  <v-container fluid>
    <v-layout wrap row align-start justify-space-between>
      <v-flex xs12 class="pa-1">
        <BListFilter
          v-model="form"
          label="Поиск по логину и имени"
          :skeleton="skeleton"
          :data="data"
          dense
          @change="onChangeDebounced"
        />
      </v-flex>
      <v-flex xs12 md4 class="pa-1">
        <BAutocompleteCommon
          v-model="form.data_collection_id"
          $type="data-collection"
          :return-object="false"
          :skeleton="skeleton"
          @input="onChangeDebounced"
        />
      </v-flex>
      <v-flex xs12 md4 class="pa-1">
        <BAutocompleteSelect
          v-model="form.status"
          :skeleton="skeleton"
          :options="statuses"
          item-value="value"
          item-text="text"
          :return-object="false"
          label="Статус"
          @change="onChangeDebounced"
        />
      </v-flex>
      <v-flex xs12 md4 class="pa-1">
        <BTextFieldDate
          v-model="form.publish_date"
          :skeleton="skeleton"
          :max="new Date()"
          label="Дата подачи"
          @input="onChangeDebounced"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BTextFieldDate from '@/components/forms/BTextFieldDate.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'
import BAutocompleteSelect from '@/components/forms/BAutocompleteCommon/BAutocompleteSelect.vue'
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'
import { FormdataStatusesFilterOptions } from '@/typings/api/Formdata'

const createDefaultDataFilters = () => ({
  ...createDefaultData(),
  data_collection_id: void 0,
  status: void 0,
  publish_date: void 0,
})


export default {
  name: 'FormDataFilter',
  components: {
    BListFilter,
    BTextFieldDate,
    BAutocompleteCommon,
    BAutocompleteSelect,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
  data: () => ({
    statuses: FormdataStatusesFilterOptions,
  }),
}
</script>
